import React from 'react';
import VisionBoard from '../VisionBoard';
import BrandingGuide from '../BrandingGuide';
import SetupChecklist from '../SetupChecklist';
import TaskList from '../TaskList';

interface DevelopmentWorkspaceProps {
  activeArea: string;
}

export default function DevelopmentWorkspace({ activeArea }: DevelopmentWorkspaceProps) {
  const renderContent = () => {
    switch (activeArea) {
      case 'vision':
        return <VisionBoard />;
      case 'brand':
        return <BrandingGuide />;
      case 'docs':
        return (
          <div className="space-y-4">
            <p className="text-gray-600">Business documentation and resources will be shown here.</p>
          </div>
        );
      default:
        return (
          <div className="space-y-6">
            <SetupChecklist />
            <TaskList />
          </div>
        );
    }
  };

  return renderContent();
}